import LayoutMain from './../../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../../ProgressHUD/index.vue'
import GoogleMap from './../../../GoogleMap/VueGoogleMap.vue'
import { Api, Helper } from './../../../../services'

export default {
  name: 'ProjectCrowfunding',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    GoogleMap,
  },
  data() {
    return {
      data: null,
      datacollection: {
        labels: [],
        actualData: [],
        predictedData: [],
      },
      userCountProject: 0,
      newPost: {
        id: 0,
        title: '',
        picture: null,
        description: '',
      },
      editPost: {
        id: 0,
        title: '',
        picture: null,
        description: '',
      },
      validationMessage: null,
    }
  },
  filters: {
    filterDate(value) {
      if (value) {
        var monthNames = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ]
        var monthNamesShort = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ]

        var date = new Date(value),
          month = monthNamesShort[date.getMonth()],
          day = date.getDate(),
          year = date.getFullYear()

        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day

        return month + '. ' + day + ', ' + year
      }

      return ''
    },
  },
  methods: {
    payConsultingService() {
      alert('This feature is not yet implemented')
    },

    parseDate: function(input) {
      var parts = input.split('/')
      return new Date(parts[0], parts[1] - 1, parts[2])
    },

    isNullOrUndefined: function(value) {
      return value === null || value === undefined
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files) {
        this.newPost.picture = []
        return
      }

      this.newPost.picture = files
    },

    onFileChangeForEditPost(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files) {
        this.editPost.picture = []
        return
      }

      this.editPost.picture = files
    },

    goToEdit() {
      this.$router.push(
        '/project/systemsdetail/Crowdfunding/edit/' + this.data.project._id
      )
    },

    async addNewPost() {
      var self = this

      const isValid = await this.$validator.validateAll('formNewPosts')
      if (!isValid) return

      this.$refs.progress.show()

      var formData = new FormData()
      formData.append('title', self.newPost.title)
      formData.append('text', self.newPost.description)
      formData.append('files0', self.newPost.picture[0])
      formData.append('project_id', self.data.project._id)

      var response = await Api.addPostToProject(formData)
      if (response.data) {
        // Add new post to list posts
        this.data.posts.push(response.data.post)

        // Set empty value in form for New Post
        self.newPost.id = 0
        self.newPost.title = ''
        self.newPost.description = ''
        self.newPost.picture = []

        this.$refs.Picture.value = ''
        this.$refs.Picture2.value = ''

        $('#modalAddPost').modal('close')
      } else {
        console.log(response.message)
        alert('Error: ' + response.message)
      }

      this.$refs.progress.hide()
    },

    async saveEditPost() {
      var self = this

      const isValid = await this.$validator.validateAll('formEditPosts')
      if (!isValid) return

      this.$refs.progress.show()

      var formData = new FormData()
      formData.append('id', self.editPost.id)
      formData.append('title', self.editPost.title)
      formData.append('text', self.editPost.description)
      formData.append('project_id', self.editPost.project_id)

      if (self.editPost.picture && self.editPost.picture[0]) {
        formData.append('files0', self.editPost.picture[0])
      }

      var response = await Api.editPostInProject(formData)
      if (response.data) {
        // Edit post
        const post = this.data.posts.find(x => x._id === self.editPost.id)
        post.id = self.editPost._id
        post.title = self.editPost.title

        post.text = self.editPost.description
        post.project_id = self.editPost.project_id

        if (response.data.post.image && response.data.post.image.length > 0) {
          post.image = response.data.post.image
        }

        $('#modalEditPost').modal('close')
      } else {
        console.log(response.message)
        alert('Error: ' + response.message)
      }

      this.$refs.progress.hide()
    },

    openDialogForEditPost(post) {
      this.editPost.id = post._id
      this.editPost.title = post.title
      this.editPost.picture = null
      this.editPost.description = post.text
      this.editPost.project_id = post.project_id

      this.$refs.editPicture.value = ''
      this.$refs.editPicture2.value = ''

      $('#modalEditPost input[name="Title"]')
        .siblings('label')
        .addClass('active')
      $('#modalEditPost textarea')
        .siblings('label')
        .addClass('active')

      $('#modalEditPost').modal('open')
    },

    async removePost(post) {
      this.$refs.progress.show()

      var response = await Api.removePostInProject(post._id)
      if (response.data) {
        this.removeElementInArray(this.data.posts, post)
      } else {
        console.log(response.message)
        alert('Error: ' + response.message)
      }

      this.$refs.progress.hide()
    },

    removeElementInArray(array, element) {
      const index = array.indexOf(element)
      if (index !== -1) {
        array.splice(index, 1)
      }
    },
  },
  async created() {
    var response = await Api.getSystemsDetailById(this.$route.params.id)
    if (response.data && !response.data.error) {
      var resultDate = response.data.results[0]
      if (resultDate) {
        this.data = resultDate
        this.data.project.businessPlan = JSON.parse(
          resultDate.project.businessPlan
        )

        await new Promise(resolve => this.$nextTick(resolve))

        this.$refs.googleMap.setPosition(
          this.data.project.latitude,
          this.data.project.longitude
        )
      }
    } else {
      console.error('Something went wrong.')
      this.validationMessage = 'Something went wrong.'
    }

    var response = await Api.getCountProjectsById(this.$route.params.id)
    if (response.data && !response.data.error) {
      this.userCountProject = response.data.results
    } else {
      console.error('Something went wrong.')
    }

    this.$refs.progress.hide()
  },
  mounted() {
    // Configuration materialize css
    var self = this
    $('.modal').modal()
    $('select').material_select()
  },
  watch: {
    data: function(val, oldVal) {
      this.$nextTick(() => {
        $('select').material_select()
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/SystemsDetail/ProjectCrowdfunding/ProjectCrowdfunding.component.js